import React from 'react';

import css from './MIDIPage.module.scss';
import {MonitorSection} from './monitor/MonitorSection';
import {MobileAppSection} from './mobile-app/MobileAppSection';
import {SetupMidiStep} from './step/SetupMidiStep';
import {HeartRateMonitorMidiStep} from './step/HeartRateMonitorMidiStep';
import {useMidi} from './WebMidiService';
import {useScrollService} from './ScrollService';
import {MIDIDeviceSetupSection} from './midi-device-setup/MIDIDeviceSetupSection';
import {SetupVRChatSection} from './setup-vr-chat/SetupVRChatSection';
import {VRWorldSection} from './vr-world/VRWorldSection';
import {Promo} from './Promo';

export const MIDIPage: React.FC<{}> = () => {
  let midi = useMidi();
  let scroller = useScrollService();

  return (
    <div className={css.root}>
      <div className={css.header}>
        <h1>Pulsoid Heart Rate to VRChat</h1>
      </div>
      <Promo />
      <div className={css.content}>
        <div className={css.setupContainer}>
          <div className={css.warning}>
            Set-up environment to stream heart rate to VRChat
          </div>
          <div>
            <div className={css.status}>
              <div className={css.info}>
                Follow Set-up guide below to stream your HR to VRChat. Also, see
                Troubleshooting guide, or Ask in Discord
              </div>
              <div className={css.statusContainer}>
                <HeartRateMonitorMidiStep
                  midi={midi}
                  scroller={scroller.current}
                />
                <hr className={css.divider} />
                <SetupMidiStep midi={midi} scroller={scroller.current} />
              </div>
            </div>
          </div>
        </div>

        <MonitorSection />
        <MobileAppSection />
        <MIDIDeviceSetupSection scroller={scroller.current} />
        <SetupVRChatSection />
        <VRWorldSection />
      </div>
    </div>
  );
};
